import { useParams } from "react-router-dom";
import { ApiError } from "@/lib/api-client";
import { usePublicPortfolioItem } from "@/features/portfolio-items/hooks";
import { NotFound } from "@/pages/NotFound";
import { PublicError, PublicLoading } from "@/pages/public/PublicState";
import { PortfolioDetail } from "./PortfolioDetail";
import { SEO } from "@/components/seo/SEO";
import { getPortfolioImage, getShortDescription } from "./portfolio-utils";

export function PortfolioDetailPage() {
  const { slug } = useParams();
  const query = usePublicPortfolioItem(slug ?? null);

  if (query.isLoading) return <PublicLoading label="Loading portfolio project..." />;

  if (query.isError) {
    if (query.error instanceof ApiError && query.error.status === 404) return <NotFound />;
    return <PublicError label="Unable to load this portfolio project." />;
  }

  if (!query.data) return <NotFound />;

  const image = getPortfolioImage(query.data);
  return (
    <>
      <SEO title={query.data.title} description={getShortDescription(query.data.description)} ogImage={image?.url} />
      <PortfolioDetail item={query.data} />
    </>
  );
}
